import React from "react";
import { Sparkles, HelpCircle, Bell, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const Header = () => {
  const { user, logout } = useAuth();
  return (
    <header className="h-16 bg-white border-b border-gray-200 flex items-center justify-between px-6 sticky top-0 z-30" data-testid="app-header">
      <div className="flex items-center gap-3">
        <div className="relative">
          <div className="w-9 h-9 rounded-full bg-[#EDE9FE] flex items-center justify-center" data-testid="header-sparkle-icon">
            <Sparkles className="text-[#7C3AED]" size={18} />
          </div>
          <span className="absolute -top-0.5 -right-0.5 w-2.5 h-2.5 bg-emerald-500 rounded-full pulse-green border-2 border-white" />
        </div>
        <div>
          <p className="text-xs text-gray-500">Welcome back</p>
          <p className="text-sm font-semibold text-gray-900">{user?.name || "Guest"}</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button className="w-9 h-9 rounded-full hover:bg-gray-100 flex items-center justify-center text-gray-600" data-testid="header-help-icon">
          <HelpCircle size={18} />
        </button>
        <button className="w-9 h-9 rounded-full hover:bg-gray-100 flex items-center justify-center text-gray-600 relative" data-testid="header-bell-icon">
          <Bell size={18} />
          <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full" />
        </button>
        <button onClick={logout} className="w-9 h-9 rounded-full hover:bg-gray-100 flex items-center justify-center text-gray-600" data-testid="header-logout-btn" title="Sign out">
          <LogOut size={18} />
        </button>
      </div>
    </header>
  );
};

export default Header;
